/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createObservableDataAction, IAction, ICreateActionContext } from '@msdyn365-commerce/core';
import { retailAction } from '@msdyn365-commerce/retail-proxy/dist';
import { createGetByCustomerInput } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CommerceListsDataActions.g';
import { CommerceList } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

const createWishlistInput = (inputData: ICreateActionContext) => {
    if (inputData.requestContext && inputData.requestContext.user && inputData.requestContext.user.isAuthenticated) {
        return createGetByCustomerInput({}, null);
    }

    throw new Error('[get-wishlist-by-customer-id] Unable to create input for getWishlists');
};

/**
 * Get Org Unit Configuration Data Action.
 */
export const retailActionDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/retail-actions/get-wishlist-by-customer-id',
    action: <IAction<CommerceList[]>>retailAction,
    input: createWishlistInput
});

export default retailActionDataAction;
